import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Yen",
  "use": "icon-Yen-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-Yen\">\n<path fill-rule=\"evenodd\" fill=\"rgb(158, 191, 255)\" d=\"M10.000,20.000 C4.477,20.000 -0.000,15.523 -0.000,10.000 C-0.000,4.477 4.477,0.000 10.000,0.000 C15.523,0.000 20.000,4.477 20.000,10.000 C20.000,15.523 15.523,20.000 10.000,20.000 ZM10.000,1.905 C5.529,1.905 1.905,5.529 1.905,10.000 C1.905,14.471 5.529,18.095 10.000,18.095 C14.471,18.095 18.095,14.471 18.095,10.000 C18.095,5.529 14.471,1.905 10.000,1.905 ZM11.000,16.000 L9.000,16.000 L9.000,14.000 L6.000,14.000 L6.000,12.000 L9.000,12.000 L9.000,11.000 L6.000,11.000 L6.000,9.000 L7.500,9.000 L6.000,6.000 L8.000,5.000 L10.000,9.000 L12.000,5.000 L14.000,6.000 L12.500,9.000 L14.000,9.000 L14.000,11.000 L11.000,11.000 L11.000,12.000 L14.000,12.000 L14.000,14.000 L11.000,14.000 L11.000,16.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Yen.svg
// module id = 4rDY
// module chunks = 70